import React, { useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { Helmet } from 'react-helmet-async';
import { axiosKK } from '../services/networkRequest';
import errorMessage from '../services/errorMessage';
import SubmitButton from '../components/SubmitButton';
import { Link } from 'react-router-dom';

function ForgotPasswordComponent({ history }: RouteComponentProps): JSX.Element {
  const [email, setEmail] = useState('');
  const [successMessage, setSuccessMessage] = useState<string>();
  const [networkError, setNetworkError] = useState<string>();
  const [fieldError, setFieldError] = useState<string>();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validate = (): boolean => {
    if (!email || email.length < 4) {
      setFieldError('No email');
      return false;
    }
    setFieldError(undefined);
    return true;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) return;

    setIsSubmitting(true);
    setNetworkError(undefined);
    setSuccessMessage(undefined);

    axiosKK
      .post<{}>('/forgottenPassword', { email })
      .then(() => {
        setSuccessMessage('We have emailed you a reset link');
      })
      .catch((error) => {
        errorMessage(setNetworkError)(error);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <div className="auth-page">
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      
      <div className="auth-card">
        <button type="button" className="auth-card__back" onClick={() => history.goBack()}>
          &larr; Back
        </button>

        <div className="auth-card__header">
          <h3>Forgot Password</h3>
          <p>Enter your email and we'll send you a reset link</p>
        </div>

        {networkError && (
          <div className="auth-card__error">{networkError}</div>
        )}

        {successMessage ? (
          <div className="auth-card__success">
            {successMessage}, <Link to="/login">Back to Login</Link>
          </div>
        ) : (
          <form className="auth-card__form" onSubmit={handleSubmit}>
            <div className="auth-card__field">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
              />
              {fieldError && (
                <span className="field-error">{fieldError}</span>
              )}
            </div>

            <SubmitButton disabled={isSubmitting} isSubmitting={isSubmitting}>
              Send Reset Link
            </SubmitButton>
          </form>
        )}

        <div className="auth-card__toggle">
          <p>
            Remember your password?{' '}
            <button type="button" onClick={() => history.push('/login')}>
               Log in
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}

export default withRouter(ForgotPasswordComponent);
